import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { L10nTranslationService } from 'angular-l10n';
import { NavbarSchema } from 'shared/components/navbar/navbar.model';
import { ClassificationService } from 'core/classification.service';
import { SamplicityPermission } from '../dtp/common/permissions';
import { ClassificationValues } from './common/classification-value';
import { ReferenceDataService } from 'core/reference-data.service';
import { SecurityService } from 'core/security.service';
import { ClientService } from 'core/client.service';
import { TenantModuleDto } from 'shared/service-clients/tenant';

@Component({
  selector: 'samplicity-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private readonly idTokenKey: string = 'samplicity-id-token';

  navbarSchema: NavbarSchema;
  selectedClientId: string;
  isLoading = false;
  isDTP:boolean = false;
  isFG:boolean = false;
  tenantModule:any = [];
  permissions:any;

  constructor(
    private translationService: L10nTranslationService,
    private classificationService: ClassificationService,
    private referenceDataService: ReferenceDataService,
    private securityService: SecurityService,
    private titleService: Title,
    private clientService: ClientService,
  ) {
  }

  ngOnInit(): void {
    this.isLoading = true;
    const tokenIdExistFlag = localStorage.getItem(this.idTokenKey);
    if (tokenIdExistFlag) {
      this.translationService.init().then(() => {
      this.referenceDataService.load();
      this.classificationService.load();
      this.securityService.load();
      this.translationService.onChange().subscribe(() => {
      this.titleService.setTitle(this.translationService.translate('SamplicityTPLAppTitle'));
    });
    this.handleSelectedClientChange();
   });
  }
}

  refresh(): void {
    location.reload();
  }

  handleSelectedClientChange(): void {
    this.clientService.selectedClientIdAsync.subscribe((id) =>  {
      this.selectedClientId = id;
      //this.setNavbar();
      this.securityService.userAccessSubject.subscribe((userAccess: any) => {
        if (userAccess) {
          this.permissions = userAccess.permissions;
        } else {
          //this.setNavbar();
        }
        this.isLoading = false;
      });
    });
  }

  private hasPermission(permission: string, userPermissions: string[]){
    return this.hasAnyPermissions([permission], userPermissions);
  }

  private hasAnyPermissions(permissions: string[], userPermissions: string[]): boolean {
    if (userPermissions && permissions) {
      for (const permission of permissions) {
        if (userPermissions.find(x => x.toLowerCase() === permission.toLowerCase())) {
          return true;
        }
      }
    }
    return false;
  }

  private setDtrAndFgMenuVisibility(): void {
    this.clientService.getCurrentClientDetails().subscribe((client) => {
      if (client) {
        if (client.tenantModules.length === 1) {
          const status = client.tenantModules[0].tenantModuleStatusClassificationValueId;
          const isActive = (
            status === ClassificationValues.TENANT_MODULE_STATUS_ACTIVE
            || status === ClassificationValues.TENANT_MODULE_STATUS_NEW
          );
          this.clientService.setIsCurrentClientActive(isActive);
        } else {
          this.clientService.setIsCurrentClientActive(false);
        }
        this.setTenantModules(client.tenantModules);
      }
    });
  }

  private setTenantModules(tenantModules: Array<TenantModuleDto>) {
    if (tenantModules) {
      for (const navbarSchemaLink of this.navbarSchema.links) {
        if (navbarSchemaLink.menu && navbarSchemaLink.menu.length > 0) {
          for (const menu of navbarSchemaLink.menu){
            if (menu.classificationType === 'TENANT_MODULE') {
              let showMenu = false;
              for (const link of menu.links) {
                if (link.classificationValue === ClassificationValues.TENANT_MODULE_TYPE_DTP) {
                  const tm = tenantModules.find(x => x.moduleId === link.classificationValue);
                  if (tm) {
                    link.hide = false;
                    link.url = tm.tenantModuleUrlText;
                    showMenu = true;
                  } else {
                    link.hide = true;
                  }
                }
                if (link.classificationValue === ClassificationValues.TENANT_MODULE_TYPE_FGPORTAL) {
                  const tm = tenantModules.find(x => x.moduleId === link.classificationValue);
                  if (tm) {
                    link.hide = false;
                    link.url = tm.tenantModuleUrlText;
                    showMenu = true;
                  } else {
                    link.hide = true;
                  }
                }
              }
              if (showMenu) {
                menu.hide = false;
              } else {
                menu.hide = true;
              }
            }
          }
        }
      }
    }
  }


  setNavbar(userPermissions?: string[]): void {
    if (!userPermissions) {
      userPermissions = [];
    }
    this.navbarSchema = new NavbarSchema();
    this.navbarSchema.logoPermissions = [];
    this.navbarSchema.logoLink = `/${this.selectedClientId}/dashboard`;
    this.navbarSchema.logoTitle = 'Navbar.SamplicityPlatform';
    this.navbarSchema.links = [
      {
        display: 'Navbar.Orders',
        link: `/${this.selectedClientId}/orders`,
        id: 'linkOrders',
        hide: !this.hasPermission(SamplicityPermission.Order.OrdersListView, userPermissions),
        permissions: [SamplicityPermission.Order.OrdersListView]
      },
      {
        display: 'Navbar.DataEntry.DataEntryOrders',
        link: `/${this.selectedClientId}/orders/data-entry`,
        id: 'linkDataEntryOrders',
        hide: !this.hasPermission(SamplicityPermission.DataEntryOrder.DataEntryOrderListView, userPermissions),
        permissions: [SamplicityPermission.DataEntryOrder.DataEntryOrderListView]
      },
      {
        display: 'Navbar.MitigationOrders.Mitigation',
        id: 'linkMitigationOrders',
        hide: !this.hasAnyPermissions(
              [SamplicityPermission.MitigationOrder.MitigationOrdersListView,
               SamplicityPermission.MitigationCertificate.MitigationCertificateListView],
              userPermissions),
        permissions: [SamplicityPermission.MitigationOrder.MitigationOrdersListView],
        menu:[
          {
            links: [
              {
                display: 'Navbar.MitigationOrders.ExceptionOrders',
                link: `/${this.selectedClientId}/orders/mitigation/exception`,
                id: 'childlinkMitigateExceptionOrders',
                hide: !this.hasPermission(SamplicityPermission.MitigationOrder.MitigationOrdersListView, userPermissions),
                permissions: [SamplicityPermission.MitigationOrder.MitigationOrdersListView],
              },
              {
                display: 'Navbar.MitigationOrders.OnHoldOrders',
                link: `/${this.selectedClientId}/orders/mitigation/on-hold`,
                id: 'childlinkMitigateOnHoldOrders',
                hide: !this.hasPermission(SamplicityPermission.OnHoldOrder.OnHoldOrderListView, userPermissions),
                permissions: [SamplicityPermission.OnHoldOrder.OnHoldOrderListView],
              },
              {
                display: 'Navbar.MitigationOrders.Certification',
                link: `/${this.selectedClientId}/orders/mitigation/certificate`,
                id: 'childlinkCertification',
                hide: !(this.hasPermission(SamplicityPermission.MitigationCertificate.MitigationCertificateListView, userPermissions) && (this.isFG)),
                permissions: [SamplicityPermission.MitigationCertificate.MitigationCertificateListView],
              }
            ]
          }
        ]
      },
      {
        display: 'Navbar.Offers',
        link: `/${this.selectedClientId}/admin/offers`,
        id: 'linkOffers',
        hide: !(this.hasPermission(SamplicityPermission.Offer.OfferListView, userPermissions) && this.isDTP),
        permissions: [SamplicityPermission.Offer.OfferListView]
      },
      {
        display: 'Navbar.Recipients.Recipients',
        id: 'linkRecipient',
        hide: !this.hasAnyPermissions([SamplicityPermission.HCP.HCPListView,SamplicityPermission.Pharmacist.PharmacistListView], userPermissions),
        menu:[
          {
            links:[
              {
                display: 'Navbar.Recipients.Hcps',
                link: `/${this.selectedClientId}/admin/hcps`,
                id: 'linkHcps',
                hide: !(this.hasPermission(SamplicityPermission.HCP.HCPListView, userPermissions) && this.isDTP),
                permissions: [SamplicityPermission.HCP.HCPListView]
              },
              {
                display: 'Navbar.Recipients.Pharmacists',
                link: `/${this.selectedClientId}/admin/pharmacists`,
                id: 'linkPharmacists',
                hide: !(this.hasPermission(SamplicityPermission.Pharmacist.PharmacistListView, userPermissions) && this.isFG),
                permissions: [SamplicityPermission.Pharmacist.PharmacistListView]
              }
            ]
          }
        ],
      },
      {
        display: 'Navbar.Communications',
        link: `/${this.selectedClientId}/communications`,
        id: 'linkCommunications',
        hide: !this.hasPermission(SamplicityPermission.Communication.CommunicationListView, userPermissions),
        permissions: [SamplicityPermission.Communication.CommunicationListView]
      },
      {
        display: 'Navbar.Reports',
        link: `/${this.selectedClientId}/reports`,
        id: 'linkReports',
        hide: !this.hasPermission(SamplicityPermission.Reporting.ReportsView, userPermissions),
        permissions: [SamplicityPermission.Reporting.ReportsView]
      },
      {
        display: 'Navbar.Administration.Administration',
        link: '/' + this.selectedClientId + '/admin',
        id: 'linkAdmin',
        hide: !this.hasAnyPermissions([
          SamplicityPermission.User.UserListView,
          SamplicityPermission.Client.ClientDetailView,
          SamplicityPermission.Brand.BrandListView,
          SamplicityPermission.Product.ProductListView,
          SamplicityPermission.Customer.CustomerListView,
          SamplicityPermission.Program.ProgramListView,
          SamplicityPermission.DNH.DNHListView
        ], userPermissions),
        menu: [
          {
            title: 'Navbar.Administration.SystemAdministration',
            hide: !this.hasAnyPermissions([
              SamplicityPermission.User.UserListView
            ], userPermissions),
            links: [
              {
                display: 'Navbar.Administration.Users.Users',
                link: '/' + this.selectedClientId + '/admin/users',
                id: 'linkUsers',
                menu: [
                  {
                    links: [
                      {
                        display: 'Navbar.Administration.Users.ExistingUsers',
                        link: '/' + this.selectedClientId + '/admin/users',
                        id: 'linkExistingUsers',
                        hide: !this.hasPermission(SamplicityPermission.User.UserListView, userPermissions),
                        permissions: [SamplicityPermission.User.UserListView]
                      },
                      {
                        display: 'Navbar.Administration.Users.NewUsers',
                        link: '/' + this.selectedClientId + '/admin/users/ad-users',
                        id: 'linkNewUsers',
                        hide: !this.hasPermission(SamplicityPermission.User.UserListView, userPermissions),
                        permissions: [SamplicityPermission.User.UserListView]
                      },
                    ]
                  }
                ]
              },
              {
                display: 'Navbar.Administration.Roles',
                link: '/' + this.selectedClientId + '/admin/roles',
                id: 'linkRoles',
                hide: !this.hasPermission(SamplicityPermission.Role.ViewRoleList, userPermissions),
                permissions: [SamplicityPermission.Role.ViewRoleList]
              }
            ]
          },
          {
            title: 'Navbar.Administration.ClientAdministration',
            hide: !this.hasAnyPermissions([
              SamplicityPermission.Client.ClientDetailView,
              SamplicityPermission.Brand.BrandListView,
              SamplicityPermission.Product.ProductListView,
              SamplicityPermission.Customer.CustomerListView,
              SamplicityPermission.Program.ProgramListView,
              SamplicityPermission.DNH.DNHListView
            ], userPermissions),
            links: [
              {
                display: 'Navbar.Administration.ClientDetail',
                link: '/' + this.selectedClientId + '/admin/client/',
                id: 'linkClientDetail',
                hide: !this.hasPermission(SamplicityPermission.Client.ClientDetailView, userPermissions),
                permissions: [SamplicityPermission.Client.ClientDetailView],
                menuChildLinks: ['existing', 'new']
              },
              {
                display: 'Navbar.Administration.Brands',
                link: '/' + this.selectedClientId + '/admin/brands',
                id: 'linkBrand',
                hide: !this.hasPermission(SamplicityPermission.Brand.BrandListView, userPermissions),
                permissions: [SamplicityPermission.Brand.BrandListView]
              },
              {
                display: 'Navbar.Administration.Products.Products',
                link: '',
                id: 'linkProducts',
                hide: !this.hasAnyPermissions([
                  SamplicityPermission.Product.ProductListView
                ], userPermissions),
                menu: [
                  {
                    links: [
                      {
                        display: 'Navbar.Administration.Products.ExistingProducts',
                        link: '/' + this.selectedClientId + '/admin/products/existing',
                        icon: '',
                        id: 'linkExistingProducts',
                        hide: !this.hasPermission(SamplicityPermission.Product.ProductListView, userPermissions),
                        permissions: [SamplicityPermission.Product.ProductListView]
                      },
                      {
                        display: 'Navbar.Administration.Products.NewProducts',
                        link: '/' + this.selectedClientId + '/admin/products/new',
                        icon: '',
                        id: 'linkNewProducts',
                        hide: !this.hasPermission(SamplicityPermission.Product.ProductListView, userPermissions),
                        permissions: [SamplicityPermission.Product.ProductListView]
                      },
                    ]
                  }
                ]
              },
              {
                display: 'Navbar.Administration.Customers',
                link: '/' + this.selectedClientId + '/admin/customers',
                id: 'linkCustomer',
                hide:!this.hasPermission(SamplicityPermission.Customer.CustomerListView, userPermissions),
                permissions: [SamplicityPermission.Customer.CustomerListView]
              },
              {
                display: 'Navbar.Administration.Programs',
                link: '/' + this.selectedClientId + '/admin/programs',
                id: 'linkPrograms',
                hide: !this.hasPermission(SamplicityPermission.Program.ProgramListView, userPermissions),
                permissions: [SamplicityPermission.Program.ProgramListView]
              },
              {
                display: 'Navbar.Administration.DoNotHonorExlusions',
                link: '/' + this.selectedClientId + '/admin/donothonorexclusions',
                id: 'linkDoNotHonorExlusions',
                hide: !this.hasPermission(SamplicityPermission.DNH.DNHListView, userPermissions),
                permissions: [SamplicityPermission.DNH.DNHListView]
              }
            ]
          }
        ]
      }
    ];
  }
}

